// eslint-disable-next-line prebid/validate-imports
import { AD_RENDER_FAILED_REASON } from '../../../src/constants.js';

export const ERROR_NO_AD = AD_RENDER_FAILED_REASON.NO_AD;
